import React, { useState } from 'react';
import { Image } from 'src/ui/components';
import { ActionButton } from 'src/ui/components';
import KeymastersPotCheckbox from '../../../Checkbox';
import { weiToEther } from 'src/base/utils';

export default function YourRewardsTabAdvancedMode({ keys, onClaimClick, paused }){
	const [selectedKeys, setSelectedKeys] = useState([]); // stores selected keys ids
	const disableClaimButton = selectedKeys.length === 0 || paused;

	function onKeySelectClick( keyId ){
		const isSelected = selectedKeys.includes( keyId );

		if( isSelected ){
			setSelectedKeys( selectedKeys.filter( ( id )=>id !== keyId ) );
		}
		else{
			setSelectedKeys([...selectedKeys, keyId]);
		}
	}

	// advanced mode wrapper
	return <div className=' flex flex-col items-center'
	>
		<p className='text-sm text-[#D9D9D9] mt-[48px]'>Select which keys you want to claim the reward for.</p>

		{/* list wrapper */}
		<div className='w-full mt-[52px]'>
			{keys.map( ( key )=>{
				const isSelected = selectedKeys.includes( key.id );
				const claimableDisplay = `${ Number( weiToEther( key.claimable ) ).toFixed( 4 ) } ETH`;
				// list item
				return <div key={key.id}
					className='flex w-full justify-between items-center px-20 box-border max-[900px]:px-12 max-[700px]:px-8 max-[600px]:mt-[40px] max-[600px]:px-2 '>
					<KeymastersPotCheckbox 
						variation="regular"
						isSelected={isSelected}
						disabled={paused}
						onClick={()=>onKeySelectClick( key.id )}/>
					<Image 	
						src="/images/key.png" 
						width={153} 
						height={127}
						className='w-[71px] h-[86px] max-[500px]:w-[55px] max-[500px]:h-[67px] '
					/>
					<div className='flex flex-col items-center  w-[20%]  max-[500px]:w-[25%] '> 
						<span className='mb-4 text-[#B3FE00] uppercase font-semibold text-base max-[500px]:text-[14px]'>Key Id</span> 
						<span className="text-[40px] font-bold -f-family-burbank uppercase text-white max-[700px]:text-[36px] max-[500px]:text-[24px] max-[400px]:text-[20px]">
#
							{key.id}
						</span>
					</div>

					<div 
						className='flex flex-col items-center w-[20%]  max-[800px]:mx-[60px] max-[700px]:mx-[0px] max-[500px]:w-[25%]'> 
						<span className='mb-4 text-[#B3FE00] uppercase font-semibold text-base max-[500px]:text-[14px]'>Claimable</span> 
						<span className="text-2xl font-bold -f-family-burbank uppercase text-white max-[700px]:text-[36px] max-[500px]:text-[24px] max-[400px]:text-[20px]">{claimableDisplay}</span>
					</div>
				</div>;
			})}
		</div>
		<ActionButton disabled={disableClaimButton}
			onClick={()=>onClaimClick( selectedKeys )}
			className='w-auto h-[64px] text-[32px] mt-[48px]'
			textContent={`Claim For ${selectedKeys.length} Keys`}/>
	</div>;
}
